import { Divider, Skeleton } from "antd"
import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { useNavigate, useParams } from "react-router"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { type ProposalListItem } from "../../types/types.ts"
import { ProposalsSidebarListItem } from "./ProposalsSidebarListItem.tsx"

interface ProposalsSidebarListProps {
  hasMore: boolean
  data: ProposalListItem[]
  viewLeadAllowed?: boolean
  onLoadMoreProposal: () => void
}

export const ProposalsSidebarList = ({
  hasMore,
  data,
  viewLeadAllowed,
  onLoadMoreProposal
}: ProposalsSidebarListProps) => {
  const id = useParams()?.id as string
  const navigate = useNavigate()

  const onSelectProposal = (id: string) =>
    navigate(RoutesPaths.proposal.view(id))

  return (
    <div className={"py-3 flex-1 overflow-hidden"}>
      <div
        id={"scrollableDiv"}
        className={"size-full space-y-3 overflow-auto tailwind-scroll"}
      >
        <InfiniteScroll
          scrollableTarget="scrollableDiv"
          dataLength={data?.length}
          next={onLoadMoreProposal}
          hasMore={hasMore}
          loader={<Skeleton.Node className={"w-full h-32"} active />}
          // endMessage={<Divider plain>It is all, nothing more </Divider>}
          endMessage={<Divider />}
        >
          {data?.map((e) => (
            <ProposalsSidebarListItem
              key={e?.id}
              isActive={e?.id == id}
              proposal={e}
              viewLeadAllowed={viewLeadAllowed}
              onSelect={onSelectProposal}
            />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  )
}
